import { getIsManagedByVtex } from '~/helpers/token-info'

export type IsManagedByVtexResult = {
  isManagedByVtex: boolean
}

/**
 * Shared gate for Insertion Order (PI) eligibility on campaign create.
 *
 * Reads JWT claim `is_managed_by_vtex` (absent/undefined ⇒ false).
 * Do NOT alias this to `useAppInfo().isNetwork` / `publisherInfo.is_network`
 * / `getIsNetwork()` — those are a different product signal.
 */
export const useIsManagedByVtex = (): IsManagedByVtexResult => {
  return {
    isManagedByVtex: getIsManagedByVtex()
  }
}
